import AutocompleteCompany from './AutocompleteCompany'

export default AutocompleteCompany
